import "./tac.scss";
import m from "mithril";
import pf from "../pf";
import svg from "../svg";
import modal from "../modal/modal";
import prsorawsiblock from "../prasora-wsi-block/prasora-wsi-block";


export default () => {

    let finaldata = {};
    let wdata = [];
    let firstloading = true;
    let searchtext = "";
    let pagesize = 20;
    let set = new Set();
    let reloaddetails = {};
    let currentActivity = null;

    async function GetData() {
        await pf.APIAction("GetActivities", {})
            .then((r) => {
                if (r) {
                    if (r.wscount) {
                        r.wscount.forEach(ws => {
                            reloaddetails[ws.wid] = {
                                count: ws.count,
                                maxpage: Math.ceil(ws.count / pagesize),
                                pagenum: 1
                            };
                        })
                    }

                    r.data.forEach(i => {
                        if (!set.has(i.iid)) {
                            wdata.push(i);
                            set.add(i.iid);
                        }
                    });

                    GetFilteredData();
                }
                firstloading = false;
                m.redraw();
            });
    }

    let timeout = null;

    async function DelayedUpdate(wsid) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
            UpdateData(wsid);
        }, 800);

        GetFilteredData();
    }

    async function UpdateData(wsid) {
        let options = {};

        if (wsid) {
            options.wid = wsid;
            options.pagenum = (reloaddetails[wsid].pagenum + 1);
            m.redraw();
        }

        if (searchtext)
            options.searchtext = searchtext;

        // console.log("updating", options);

        await pf.APIAction("GetActivities", {
                ...options
            })
            .then((r) => {
                if (r) {
                    if (r.wscount) {
                        r.wscount.forEach(ws => {
                            reloaddetails[ws.wid] = {
                                count: ws.count,
                                maxpage: Math.ceil(ws.count / pagesize),
                                pagenum: 1
                            };
                        })
                    }
                    if (wsid) {
                        reloaddetails[wsid].loading = false;
                    }

                    r.data.forEach(i => {
                        if (!set.has(i.iid)) {
                            wdata.push(i);
                            set.add(i.iid);
                        }
                    });

                    GetFilteredData();
                }
                m.redraw();
            });
    }

    function GetFilteredData() {
        finaldata = {};
        let filteredData = wdata.filter(a => (pf.regexContains(a.name, searchtext) || pf.regexContains(a.wsname, searchtext)));
        filteredData.sort(function(a, b) {
            return a.dueon - b.dueon
        });
        finaldata.wslist = [...new Set(filteredData.map(a => a.wid))];
        finaldata.wslist.forEach(ws => {
            let wis = filteredData.filter(a => a.wid == ws);
            wis.sort(function(a, b) {
                return a.dueon - b.dueon
            });

            finaldata[ws] = {
                wis: wis,
                wsname: wis[0].wsname
            };

            reloaddetails[ws].pagenum = Math.ceil(wis.length / pagesize);
        });
    }

    return {
        oninit: v => {
            GetData();
        },
        view: v => {
            if (firstloading)
                return m("h1", "...loading");
            else {

                if (wdata.length == 0) {
                    return m("h1", "There are no activities due for you!!")
                } else
                    return m(".tac-wrapper", [
                        (currentActivity && m(modal, [
                            m(prsorawsiblock, {
                                wi: currentActivity,
                                onclose: e => {
                                    currentActivity = null;
                                },
                                UpdateWSinDS: () => {}
                            })
                        ])),
                        m(".tac-title", "Here are the activities due for you"),
                        m(".tac-filter-wrapper", [
                            m("input.tac-filter", {
                                type: "textbox",
                                placeholder: " S  E  A  R  C  H ",
                                value: searchtext,
                                oninput: e => {
                                    searchtext = e.target.value;
                                    DelayedUpdate();
                                }
                            })
                        ]),
                        m(".tac-item-wrapper", [
                            finaldata.wslist.map((w, k) => {
                                return m(".tac-item-list", {
                                        style: `--datadelay: ${k};`
                                    },
                                    [
                                        m(".tac-item-list-title", finaldata[w].wsname),
                                        m(".tac-item-list-wrapper", {
                                                onscroll: e => {
                                                    if (reloaddetails[w].maxpage > reloaddetails[w].pagenum)
                                                        if ((e.target.scrollTop) > (e.target.scrollHeight - e.target.clientHeight)) {
                                                            if (!reloaddetails[w].loading) {
                                                                reloaddetails[w].loading = true;
                                                                UpdateData(w);
                                                                m.redraw();
                                                            }
                                                        }
                                                }
                                            },
                                            [
                                                finaldata[w].wis.map((i, j) => {
                                                    return m(".tac-item", {
                                                        style: `--datadelay: ${j};`,
                                                        onclick: e => {
                                                            currentActivity = i;
                                                        }
                                                    }, [
                                                        m(svg),
                                                        i.name,
                                                        null,
                                                        null
                                                    ]);
                                                }),
                                                finaldata[w].loading ? m(".tac-loading", "loading") : null
                                            ])
                                    ]
                                )
                            })
                        ])
                    ])
            }
        }
    }
}